import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetProductShotHistory = (params: { searchTerm: string }): Promise<any> =>
    request({
        url: ApiURL.Query.GetProductShotHistory,
        method: RequestType.GET,
        params,
    });

const ProductShotHistoryQuery = {
    GetProductShotHistory,
};

export default ProductShotHistoryQuery;
